/**
 * Link mostrati nel dropdown utente (in alto a destra quando autenticato).
 * Modifica questo file per aggiungere/rimuovere/riordinare le voci.
 *
 * - translationKey: chiave in header.userMenu.* usata per la label localizzata
 * - roles: array di ruoli che vedono il link; [] o omesso = tutti i ruoli
 */
import { MY_DOMAIN } from './domain';

export interface UserMenuLink {
  translationKey: string;  // chiave sotto header.userMenu.*
  href: string;            // URL o path React Router
  external?: boolean;      // true = apre in nuova tab
  icon?: string;           // emoji opzionale
  roles?: string[];        // ruoli autorizzati (vuoto/omesso = tutti)
}

const USER_MENU_LINKS: UserMenuLink[] = [
  {
    translationKey: 'panel',
    href: MY_DOMAIN,
    external: true,
    icon: '🖥️',
    roles: ['model', 'agency', 'user'],
  },
  {
    translationKey: 'profile',
    href: `${MY_DOMAIN}/model-dashboard.php`,
    external: true,
    icon: '👤',
    roles: ['model'],
  },
  {
    translationKey: 'shop',
    href: `${MY_DOMAIN}/shop.php`,
    external: true,
    icon: '🛍️',
    roles: ['model', 'agency', 'user'],
  },
  {
    translationKey: 'favorites',
    href: `${MY_DOMAIN}/user-favorites.php`,
    external: true,
    icon: '❤️',
    roles: ['user'],
  },
];

export default USER_MENU_LINKS;
